import '../styles/retailers.css';
import { useInView } from 'react-intersection-observer';

/* ── Retailer list ──────────────────────────────────────────────
   logo: URL to CDN/Wikipedia logo (fallback to text badge if null)
   bg:   badge background color matching brand
   color: text color
   ─────────────────────────────────────────────────────────────── */
const RETAILERS = [
  // ── México ────────────────────────────────────────────────────
  {
    name: 'Walmart MX',
    logo: '/images/logo_wm_mx.png',
    bg: '#0071CE', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Bodega Aurrerá',
    logo: '/images/logo_bau.jpg',
    bg: '#E31837', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Walmart Express',
    logo: '/images/logo_wmxp.png',
    bg: '#0071CE', color: '#fff',
	localLogo: true,
  },
  {
    name: "Sam's MX",
    logo: '/images/logo_sams.png',
    bg: '#004990', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Chedraui',
    logo: '/images/logo_chedraui.png',
    bg: '#E31837', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Soriana',
    logo: '/images/logo_soriana.png',
    bg: '#EF3829', color: '#fff',
	localLogo: true,
  },
  {
    name: 'LaComer',
    logo: '/images/logo_lacomer.jpg',
    bg: '#FF6600', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Amazon MX',
    logo: '/images/logo_amazon_mx.png',
    bg: '#FF9900', color: '#111',
	localLogo: true,
  },
  {
    name: 'Mercado Libre',
    logo: '/images/logo_mercado_libre.jpg',
    bg: '#FFE600', color: '#333',
	localLogo: true,
  },
  {
    name: 'Rappi MX',
    logo: '/images/logo_rappi.png',
    bg: '#FF441F', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Justo',
    logo: '/images/logo_justo.jpg',
    bg: '#00C853', color: '#fff',
	localLogo: true,
  },
  {
    name: 'HEB',
    logo: '/images/logo_heb.png',
    bg: '#E31837', color: '#fff',
	localLogo: true,
  },
  {
    name: 'CasaLey',
    logo: '/images/logo_casaley.png',
    bg: '#E31837', color: '#fff',
	localLogo: true,
  },
  {
    name: 'AlSuper',
    logo: '/images/logo_alsuper.jpg',
    bg: '#003087', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Mas',
    logo: '/images/logo_mas_super.png',
    bg: '#CC0000', color: '#fff',
    localLogo: true,
  },
  {
    name: 'SurtaCe',
    logo: '/images/logo_surtace.png',
    bg: '#f5f5f5', color: '#333',
    localLogo: true,
  },
  {
    name: 'Scorpion',
    logo: '/images/logo_scorpion.jpg',
    bg: '#1a1a1a', color: '#fff',
	localLogo: true,
  },
  // ── USA ──────────────────────────────────────────────────────
  {
    name: "Sam's USA",
    logo: '/images/logo_sams_club.png',
    bg: '#004990', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Costco',
    logo: '/images/logo_costco.png',
    bg: '#005DAA', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Walmart USA',
    logo: '/images/logo_wm_usa.png',
    bg: '#0071CE', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Kroger',
    logo: '/images/logo_kroger.png',
    bg: '#003087', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Ulta',
    logo: '/images/logo_ulta.png',
    bg: '#000000', color: '#fff',
	localLogo: true,
  },
  {
    name: 'Amazon USA',
    logo: '/images/logo_amazon_usa.png',
    bg: '#FF9900', color: '#111',
	localLogo: true,
  },
];

/* Duplicate list for seamless infinite scroll */
const TRACK = [...RETAILERS, ...RETAILERS];

function RetailerBadge({ r }) {
  return (
    <div className="retailer-badge" title={r.name}>
      {r.logo ? (
        <img
          src={r.logo}
          alt={r.name}
          className="retailer-logo-img"
          loading="lazy"
          onError={(e) => {
            /* Fallback to text badge if image fails */
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      {/* Text fallback — also shown when no logo */}
      <span
        className="retailer-logo-text"
        style={{
          background: r.bg,
          color: r.color,
          display: r.logo ? 'none' : 'flex',
        }}
      >
        {r.name}
      </span>
    </div>
  );
}

function Retailers({ t }) {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <section
      ref={ref}
      className={`retailers-section ${inView ? 'retailers-visible' : ''}`}
      aria-label="Retailers monitoreados"
    >
      <p className="retailers-eyebrow">
        {t ? t('retailers_label') : 'Monitoreamos más de 25 retailers en LATAM y USA'}
      </p>

      {/* Marquee track */}
      <div className="retailers-marquee-wrap" aria-hidden="true">
        <div className="retailers-track">
          {TRACK.map((r, i) => (
            <RetailerBadge key={`${r.name}-${i}`} r={r} />
          ))}
        </div>
      </div>

      {/* Country labels */}
      <div className="retailers-regions">
        <span>🇲🇽 México</span>
        <span>🇨🇴 Colombia</span>
        <span>🇵🇪 Perú</span>
        <span>🇨🇱 Chile</span>
        <span>🇺🇸 USA</span>
      </div>
    </section>
  );
}

export default Retailers;
